
import Vue from "vue";

export default Vue.extend({
  name: "Create",

  data: () => ({
    model: {} as any,
    errorMessages: {} as any,
    rules: {
      required: [(v: string): boolean | string => !!v || "Câmp obligatoriu!"],
    },
  }),

  computed: {
    computedRules(): object {
      return {
        min: this.minLength,
      };
    },
  },

  methods: {
    minLength(number: number): Function {
      return (v: string): boolean | string =>
        (!!v && v.length >= number) || `Valoarea minima: ${number}`;
    },
    async submit(): Promise<void> {
      try {
        if ((this.$refs.form as any).validate()) {
          this.model.guard_name = "api";
          await this.$API.roles().create(this.model);
          await this.$router.push("/roles");
          await this.$store.dispatch(
            "alert/showSuccess",
            "Rol adăugat cu succes."
          );
        }
      } catch (e) {
        if (e.hasOwnProperty("errors")) {
          this.errorMessages = e.errors;
          setTimeout(() => {
            this.errorMessages = {};
          }, 2000);
        }
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
  },
});
